// Affiliate product database with keyword matching
export interface AffiliateProduct {
  id: string;
  name: string;
  description: string;
  price: string;
  imageUrl: string;
  affiliateUrl: string;
  category: string;
  keywords: string[];
}

// Sample affiliate products with working links
// Note: These are example links - replace with actual affiliate links when available
export const affiliateProducts: AffiliateProduct[] = [
  // Travel
  {
    id: 'travel-1',
    name: 'Samsonite Carry-On Luggage',
    description: 'Durable 20" expandable spinner with TSA lock',
    price: '$129.99',
    imageUrl: 'https://images.unsplash.com/photo-1565026057447-bc90a3dceb87?w=200&h=200&fit=crop',
    affiliateUrl: 'https://www.amazon.com/s?k=samsonite+carry+on+luggage',
    category: 'travel',
    keywords: ['luggage', 'suitcase', 'carry-on', 'travel bag', 'packing', 'trip', 'vacation', 'flight', 'airport'],
  },
  {
    id: 'travel-2',
    name: 'Travel Packing Cubes Set',
    description: '6-piece compression cubes for organized packing',
    price: '$24.99',
    imageUrl: 'https://images.unsplash.com/photo-1553062407-98eeb64c6a62?w=200&h=200&fit=crop',
    affiliateUrl: 'https://www.amazon.com/s?k=packing+cubes+travel',
    category: 'travel',
    keywords: ['packing cubes', 'organizer', 'travel', 'clothes', 'pack', 'compression', 'bags'],
  },
  {
    id: 'travel-3',
    name: 'Universal Travel Adapter',
    description: 'All-in-one adapter with USB ports for 150+ countries',
    price: '$19.99',
    imageUrl: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=200&h=200&fit=crop',
    affiliateUrl: 'https://www.amazon.com/s?k=universal+travel+adapter',
    category: 'travel',
    keywords: ['adapter', 'charger', 'international', 'plug', 'electrical', 'usb', 'power', 'europe', 'asia'],
  },
  {
    id: 'travel-4',
    name: 'Travel Neck Pillow',
    description: 'Memory foam neck pillow for comfortable travel',
    price: '$29.99',
    imageUrl: 'https://images.unsplash.com/photo-1544161515-4ab6ce6db874?w=200&h=200&fit=crop',
    affiliateUrl: 'https://www.amazon.com/s?k=travel+neck+pillow+memory+foam',
    category: 'travel',
    keywords: ['pillow', 'neck', 'flight', 'sleep', 'comfort', 'plane', 'journey'],
  },
  // Home & Moving
  {
    id: 'home-1',
    name: 'Moving Boxes Kit',
    description: '20-box kit with tape and markers included',
    price: '$54.99',
    imageUrl: 'https://images.unsplash.com/photo-1600585152220-90363fe7e115?w=200&h=200&fit=crop',
    affiliateUrl: 'https://www.amazon.com/s?k=moving+boxes+kit',
    category: 'home',
    keywords: ['moving', 'boxes', 'packing', 'storage', 'cardboard', 'relocation', 'apartment', 'house'],
  },
  {
    id: 'home-2',
    name: 'Label Maker Machine',
    description: 'Portable Bluetooth label printer for organization',
    price: '$39.99',
    imageUrl: 'https://images.unsplash.com/photo-1586281380349-632531db7ed4?w=200&h=200&fit=crop',
    affiliateUrl: 'https://www.amazon.com/s?k=label+maker+portable',
    category: 'home',
    keywords: ['label', 'organize', 'storage', 'box', 'mark', 'printer', 'documents', 'files'],
  },
  {
    id: 'home-3',
    name: 'Furniture Sliders Set',
    description: '16-piece heavy furniture movers for all floors',
    price: '$12.99',
    imageUrl: 'https://images.unsplash.com/photo-1555041469-a586c61ea9bc?w=200&h=200&fit=crop',
    affiliateUrl: 'https://www.amazon.com/s?k=furniture+sliders+moving',
    category: 'home',
    keywords: ['furniture', 'move', 'floor', 'heavy', 'slide', 'couch', 'sofa', 'bed'],
  },
  // Baby & Kids
  {
    id: 'baby-1',
    name: 'Baby Monitor with Camera',
    description: 'HD video monitor with night vision and two-way audio',
    price: '$89.99',
    imageUrl: 'https://images.unsplash.com/photo-1515488042361-ee00e0ddd4e4?w=200&h=200&fit=crop',
    affiliateUrl: 'https://www.amazon.com/s?k=baby+monitor+camera',
    category: 'baby',
    keywords: ['baby', 'monitor', 'camera', 'nursery', 'newborn', 'infant', 'child', 'kids'],
  },
  {
    id: 'baby-2',
    name: 'Diaper Bag Backpack',
    description: 'Large capacity with changing pad and insulated pockets',
    price: '$42.99',
    imageUrl: 'https://images.unsplash.com/photo-1519689680058-324335c77eba?w=200&h=200&fit=crop',
    affiliateUrl: 'https://www.amazon.com/s?k=diaper+bag+backpack',
    category: 'baby',
    keywords: ['diaper', 'bag', 'baby', 'travel', 'changing', 'parent', 'mom', 'dad'],
  },
  // Office & Work
  {
    id: 'office-1',
    name: 'Standing Desk Converter',
    description: 'Height-adjustable desk riser with keyboard tray',
    price: '$189.99',
    imageUrl: 'https://images.unsplash.com/photo-1593062096033-9a26b09da705?w=200&h=200&fit=crop',
    affiliateUrl: 'https://www.amazon.com/s?k=standing+desk+converter',
    category: 'office',
    keywords: ['desk', 'standing', 'office', 'work', 'ergonomic', 'business', 'home office', 'computer'],
  },
  {
    id: 'office-2',
    name: 'Wireless Keyboard & Mouse',
    description: 'Ergonomic combo with quiet keys and long battery',
    price: '$49.99',
    imageUrl: 'https://images.unsplash.com/photo-1587829741301-dc798b83add3?w=200&h=200&fit=crop',
    affiliateUrl: 'https://www.amazon.com/s?k=wireless+keyboard+mouse+combo',
    category: 'office',
    keywords: ['keyboard', 'mouse', 'wireless', 'computer', 'office', 'typing', 'work'],
  },
  // Wedding & Events
  {
    id: 'wedding-1',
    name: 'Wedding Planner Book',
    description: 'Complete organizer with checklists and pockets',
    price: '$29.99',
    imageUrl: 'https://images.unsplash.com/photo-1519741497674-611481863552?w=200&h=200&fit=crop',
    affiliateUrl: 'https://www.amazon.com/s?k=wedding+planner+book',
    category: 'wedding',
    keywords: ['wedding', 'planner', 'organize', 'bride', 'groom', 'ceremony', 'reception', 'marriage'],
  },
  {
    id: 'wedding-2',
    name: 'Guest Book with Pen',
    description: 'Elegant hardcover guest book with gold pen',
    price: '$18.99',
    imageUrl: 'https://images.unsplash.com/photo-1519225421980-715cb0215aed?w=200&h=200&fit=crop',
    affiliateUrl: 'https://www.amazon.com/s?k=wedding+guest+book',
    category: 'wedding',
    keywords: ['guest', 'book', 'wedding', 'party', 'event', 'reception', 'signature'],
  },
  // Health & Fitness
  {
    id: 'health-1',
    name: 'Fitness Tracker Watch',
    description: 'Heart rate, sleep, and activity tracking',
    price: '$49.99',
    imageUrl: 'https://images.unsplash.com/photo-1575311373937-040b8e1fd5b6?w=200&h=200&fit=crop',
    affiliateUrl: 'https://www.amazon.com/s?k=fitness+tracker+watch',
    category: 'health',
    keywords: ['fitness', 'tracker', 'watch', 'health', 'exercise', 'gym', 'workout', 'steps', 'heart'],
  },
  {
    id: 'health-2',
    name: 'Resistance Bands Set',
    description: '5 levels with handles, door anchor, and bag',
    price: '$24.99',
    imageUrl: 'https://images.unsplash.com/photo-1598289431512-b97b0917affc?w=200&h=200&fit=crop',
    affiliateUrl: 'https://www.amazon.com/s?k=resistance+bands+set',
    category: 'health',
    keywords: ['resistance', 'bands', 'workout', 'exercise', 'fitness', 'gym', 'strength'],
  },
  // Kitchen & Cooking
  {
    id: 'kitchen-1',
    name: 'Instant Pot Multi-Cooker',
    description: '7-in-1 pressure cooker, slow cooker, and more',
    price: '$89.99',
    imageUrl: 'https://images.unsplash.com/photo-1585515320310-259814833e62?w=200&h=200&fit=crop',
    affiliateUrl: 'https://www.amazon.com/s?k=instant+pot+multi+cooker',
    category: 'kitchen',
    keywords: ['cooker', 'instant pot', 'pressure', 'kitchen', 'cooking', 'food', 'meal', 'recipe'],
  },
  {
    id: 'kitchen-2',
    name: 'Meal Prep Containers',
    description: '20-piece glass containers with snap lids',
    price: '$34.99',
    imageUrl: 'https://images.unsplash.com/photo-1544025162-d76694265947?w=200&h=200&fit=crop',
    affiliateUrl: 'https://www.amazon.com/s?k=meal+prep+containers+glass',
    category: 'kitchen',
    keywords: ['meal prep', 'containers', 'food', 'storage', 'lunch', 'glass', 'kitchen'],
  },
  // Car & Auto
  {
    id: 'car-1',
    name: 'Car Emergency Kit',
    description: 'Roadside assistance kit with jumper cables and tools',
    price: '$59.99',
    imageUrl: 'https://images.unsplash.com/photo-1449824913935-59a10b8d2000?w=200&h=200&fit=crop',
    affiliateUrl: 'https://www.amazon.com/s?k=car+emergency+kit',
    category: 'car',
    keywords: ['car', 'emergency', 'roadside', 'vehicle', 'auto', 'safety', 'jumper', 'tools'],
  },
  {
    id: 'car-2',
    name: 'Car Document Organizer',
    description: 'Glove box organizer for registration and insurance',
    price: '$14.99',
    imageUrl: 'https://images.unsplash.com/photo-1489824904134-891ab64532f1?w=200&h=200&fit=crop',
    affiliateUrl: 'https://www.amazon.com/s?k=car+document+organizer',
    category: 'car',
    keywords: ['car', 'document', 'organizer', 'registration', 'insurance', 'vehicle', 'papers', 'glove box'],
  },
  {
    id: 'car-3',
    name: 'Tire Pressure Gauge',
    description: 'Digital tire gauge for accurate readings',
    price: '$12.99',
    imageUrl: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=200&h=200&fit=crop',
    affiliateUrl: 'https://www.amazon.com/s?k=digital+tire+pressure+gauge',
    category: 'car',
    keywords: ['tire', 'pressure', 'gauge', 'car', 'vehicle', 'maintenance', 'auto', 'check'],
  },
  // Electronics
  {
    id: 'electronics-1',
    name: 'Portable Power Bank',
    description: '20000mAh fast charging power bank with LED display',
    price: '$35.99',
    imageUrl: 'https://images.unsplash.com/photo-1609091839311-d5365f9ff1c5?w=200&h=200&fit=crop',
    affiliateUrl: 'https://www.amazon.com/s?k=portable+power+bank+20000mah',
    category: 'electronics',
    keywords: ['power bank', 'charger', 'battery', 'portable', 'phone', 'usb', 'charging', 'device'],
  },
  {
    id: 'electronics-2',
    name: 'Noise Cancelling Headphones',
    description: 'Wireless headphones with active noise cancellation',
    price: '$79.99',
    imageUrl: 'https://images.unsplash.com/photo-1505740420928-5e560c06d30e?w=200&h=200&fit=crop',
    affiliateUrl: 'https://www.amazon.com/s?k=noise+cancelling+headphones+wireless',
    category: 'electronics',
    keywords: ['headphones', 'noise cancelling', 'wireless', 'audio', 'music', 'bluetooth', 'earbuds'],
  },
  {
    id: 'electronics-3',
    name: 'USB-C Hub Adapter',
    description: '7-in-1 USB-C hub with HDMI, USB 3.0, SD card reader',
    price: '$29.99',
    imageUrl: 'https://images.unsplash.com/photo-1625723044792-44de16ccb4e9?w=200&h=200&fit=crop',
    affiliateUrl: 'https://www.amazon.com/s?k=usb+c+hub+adapter',
    category: 'electronics',
    keywords: ['usb', 'hub', 'adapter', 'laptop', 'computer', 'hdmi', 'macbook', 'tech'],
  },
  {
    id: 'electronics-4',
    name: 'Wireless Earbuds',
    description: 'True wireless earbuds with charging case',
    price: '$49.99',
    imageUrl: 'https://images.unsplash.com/photo-1590658268037-6bf12165a8df?w=200&h=200&fit=crop',
    affiliateUrl: 'https://www.amazon.com/s?k=wireless+earbuds',
    category: 'electronics',
    keywords: ['earbuds', 'wireless', 'bluetooth', 'audio', 'music', 'airpods', 'headphones'],
  },
  {
    id: 'electronics-5',
    name: 'Smart Watch',
    description: 'Smartwatch with fitness tracking and notifications',
    price: '$129.99',
    imageUrl: 'https://images.unsplash.com/photo-1523275335684-37898b6baf30?w=200&h=200&fit=crop',
    affiliateUrl: 'https://www.amazon.com/s?k=smart+watch',
    category: 'electronics',
    keywords: ['smart watch', 'smartwatch', 'wearable', 'fitness', 'notifications', 'tech'],
  },
  // Camping & Outdoors
  {
    id: 'camping-1',
    name: 'Camping Tent 4-Person',
    description: 'Waterproof dome tent with easy setup',
    price: '$89.99',
    imageUrl: 'https://images.unsplash.com/photo-1504280390367-361c6d9f38f4?w=200&h=200&fit=crop',
    affiliateUrl: 'https://www.amazon.com/s?k=camping+tent+4+person',
    category: 'camping',
    keywords: ['tent', 'camping', 'outdoor', 'hiking', 'camp', 'shelter', 'backpacking'],
  },
  {
    id: 'camping-2',
    name: 'Sleeping Bag',
    description: 'Lightweight sleeping bag rated to 20°F',
    price: '$49.99',
    imageUrl: 'https://images.unsplash.com/photo-1445308394109-4ec2920981b1?w=200&h=200&fit=crop',
    affiliateUrl: 'https://www.amazon.com/s?k=sleeping+bag+camping',
    category: 'camping',
    keywords: ['sleeping bag', 'camping', 'outdoor', 'sleep', 'warm', 'hiking', 'backpacking'],
  },
  {
    id: 'camping-3',
    name: 'Portable Camp Stove',
    description: 'Compact propane stove for outdoor cooking',
    price: '$39.99',
    imageUrl: 'https://images.unsplash.com/photo-1510672981848-a1c4f1cb5ccf?w=200&h=200&fit=crop',
    affiliateUrl: 'https://www.amazon.com/s?k=portable+camping+stove',
    category: 'camping',
    keywords: ['stove', 'camping', 'cooking', 'outdoor', 'camp', 'propane', 'burner', 'fire'],
  },
  {
    id: 'camping-4',
    name: 'Hiking Backpack 50L',
    description: 'Large capacity hiking backpack with rain cover',
    price: '$69.99',
    imageUrl: 'https://images.unsplash.com/photo-1622260614153-03223fb72052?w=200&h=200&fit=crop',
    affiliateUrl: 'https://www.amazon.com/s?k=hiking+backpack+50l',
    category: 'camping',
    keywords: ['backpack', 'hiking', 'camping', 'outdoor', 'rucksack', 'trekking', 'pack'],
  },
  {
    id: 'camping-5',
    name: 'LED Camping Lantern',
    description: 'Rechargeable lantern with multiple light modes',
    price: '$24.99',
    imageUrl: 'https://images.unsplash.com/photo-1510312305653-8ed496efae75?w=200&h=200&fit=crop',
    affiliateUrl: 'https://www.amazon.com/s?k=led+camping+lantern',
    category: 'camping',
    keywords: ['lantern', 'light', 'camping', 'outdoor', 'led', 'flashlight', 'lamp'],
  },
  {
    id: 'camping-6',
    name: 'Portable Water Filter',
    description: 'Water purification straw for hiking and camping',
    price: '$19.99',
    imageUrl: 'https://images.unsplash.com/photo-1536939459926-301728717817?w=200&h=200&fit=crop',
    affiliateUrl: 'https://www.amazon.com/s?k=portable+water+filter+camping',
    category: 'camping',
    keywords: ['water filter', 'purifier', 'camping', 'hiking', 'outdoor', 'survival', 'drinking'],
  },
  // Pet Supplies
  {
    id: 'pet-1',
    name: 'Dog Crate',
    description: 'Foldable metal dog crate with divider panel',
    price: '$54.99',
    imageUrl: 'https://images.unsplash.com/photo-1587300003388-59208cc962cb?w=200&h=200&fit=crop',
    affiliateUrl: 'https://www.amazon.com/s?k=dog+crate+foldable',
    category: 'pet',
    keywords: ['dog', 'crate', 'kennel', 'pet', 'cage', 'puppy', 'training'],
  },
  {
    id: 'pet-2',
    name: 'Cat Litter Box',
    description: 'Enclosed litter box with odor control',
    price: '$39.99',
    imageUrl: 'https://images.unsplash.com/photo-1514888286974-6c03e2ca1dba?w=200&h=200&fit=crop',
    affiliateUrl: 'https://www.amazon.com/s?k=cat+litter+box+enclosed',
    category: 'pet',
    keywords: ['cat', 'litter', 'box', 'pet', 'kitten', 'feline', 'toilet'],
  },
  {
    id: 'pet-3',
    name: 'Pet Carrier Bag',
    description: 'Airline approved soft-sided pet carrier',
    price: '$34.99',
    imageUrl: 'https://images.unsplash.com/photo-1601758124510-52d02ddb7cbd?w=200&h=200&fit=crop',
    affiliateUrl: 'https://www.amazon.com/s?k=pet+carrier+airline+approved',
    category: 'pet',
    keywords: ['pet carrier', 'dog carrier', 'cat carrier', 'travel', 'airline', 'transport'],
  },
  {
    id: 'pet-4',
    name: 'Automatic Pet Feeder',
    description: 'Programmable food dispenser with timer',
    price: '$59.99',
    imageUrl: 'https://images.unsplash.com/photo-1450778869180-41d0601e046e?w=200&h=200&fit=crop',
    affiliateUrl: 'https://www.amazon.com/s?k=automatic+pet+feeder',
    category: 'pet',
    keywords: ['pet feeder', 'automatic', 'dog food', 'cat food', 'dispenser', 'feeding'],
  },
  {
    id: 'pet-5',
    name: 'Dog Leash & Collar Set',
    description: 'Adjustable collar with matching leash',
    price: '$19.99',
    imageUrl: 'https://images.unsplash.com/photo-1477884213360-7e9d7dcc1e48?w=200&h=200&fit=crop',
    affiliateUrl: 'https://www.amazon.com/s?k=dog+leash+collar+set',
    category: 'pet',
    keywords: ['dog', 'leash', 'collar', 'pet', 'walk', 'puppy', 'harness'],
  },
  // Garden & Outdoor
  {
    id: 'garden-1',
    name: 'Garden Tool Set',
    description: '10-piece stainless steel garden tools with bag',
    price: '$39.99',
    imageUrl: 'https://images.unsplash.com/photo-1416879595882-3373a0480b5b?w=200&h=200&fit=crop',
    affiliateUrl: 'https://www.amazon.com/s?k=garden+tool+set',
    category: 'garden',
    keywords: ['garden', 'tools', 'gardening', 'planting', 'shovel', 'rake', 'outdoor'],
  },
  {
    id: 'garden-2',
    name: 'Garden Hose 50ft',
    description: 'Expandable garden hose with spray nozzle',
    price: '$29.99',
    imageUrl: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=200&h=200&fit=crop',
    affiliateUrl: 'https://www.amazon.com/s?k=expandable+garden+hose',
    category: 'garden',
    keywords: ['hose', 'garden', 'water', 'watering', 'spray', 'outdoor', 'lawn'],
  },
  {
    id: 'garden-3',
    name: 'Raised Garden Bed',
    description: 'Wooden raised planter box for vegetables',
    price: '$69.99',
    imageUrl: 'https://images.unsplash.com/photo-1466692476868-aef1dfb1e735?w=200&h=200&fit=crop',
    affiliateUrl: 'https://www.amazon.com/s?k=raised+garden+bed',
    category: 'garden',
    keywords: ['garden bed', 'planter', 'raised', 'vegetables', 'growing', 'outdoor'],
  },
  // School & Learning
  {
    id: 'school-1',
    name: 'Backpack for Students',
    description: 'Laptop backpack with multiple compartments',
    price: '$34.99',
    imageUrl: 'https://images.unsplash.com/photo-1553062407-98eeb64c6a62?w=200&h=200&fit=crop',
    affiliateUrl: 'https://www.amazon.com/s?k=student+backpack+laptop',
    category: 'school',
    keywords: ['backpack', 'school', 'student', 'laptop', 'bag', 'college', 'university'],
  },
  {
    id: 'school-2',
    name: 'Planner Notebook',
    description: 'Academic planner with weekly and monthly views',
    price: '$14.99',
    imageUrl: 'https://images.unsplash.com/photo-1517842645767-c639042777db?w=200&h=200&fit=crop',
    affiliateUrl: 'https://www.amazon.com/s?k=academic+planner+notebook',
    category: 'school',
    keywords: ['planner', 'notebook', 'school', 'academic', 'study', 'calendar', 'organizer'],
  },
  {
    id: 'school-3',
    name: 'Highlighter Set',
    description: 'Assorted colors highlighter markers set',
    price: '$9.99',
    imageUrl: 'https://images.unsplash.com/photo-1456735190827-d1262f71b8a3?w=200&h=200&fit=crop',
    affiliateUrl: 'https://www.amazon.com/s?k=highlighter+set+markers',
    category: 'school',
    keywords: ['highlighter', 'markers', 'school', 'study', 'notes', 'stationery', 'pens'],
  },
  // DIY & Tools
  {
    id: 'diy-1',
    name: 'Cordless Drill Set',
    description: '20V cordless drill with bits and case',
    price: '$79.99',
    imageUrl: 'https://images.unsplash.com/photo-1504148455328-c376907d081c?w=200&h=200&fit=crop',
    affiliateUrl: 'https://www.amazon.com/s?k=cordless+drill+set',
    category: 'diy',
    keywords: ['drill', 'cordless', 'power tool', 'diy', 'tools', 'screwdriver', 'construction'],
  },
  {
    id: 'diy-2',
    name: 'Tool Box Organizer',
    description: 'Portable tool box with removable tray',
    price: '$29.99',
    imageUrl: 'https://images.unsplash.com/photo-1530124566582-a618bc2615dc?w=200&h=200&fit=crop',
    affiliateUrl: 'https://www.amazon.com/s?k=tool+box+organizer',
    category: 'diy',
    keywords: ['toolbox', 'tool box', 'organizer', 'tools', 'storage', 'garage', 'diy'],
  },
  {
    id: 'diy-3',
    name: 'Tape Measure 25ft',
    description: 'Heavy-duty tape measure with magnetic tip',
    price: '$12.99',
    imageUrl: 'https://images.unsplash.com/photo-1572981779307-38b8cabb2407?w=200&h=200&fit=crop',
    affiliateUrl: 'https://www.amazon.com/s?k=tape+measure+25ft',
    category: 'diy',
    keywords: ['tape measure', 'measuring', 'tools', 'diy', 'construction', 'ruler'],
  },
];

// Category-based product recommendations for banners
export const categoryBanners: Record<string, AffiliateProduct[]> = {
  travel: affiliateProducts.filter(p => p.category === 'travel'),
  'home-life': affiliateProducts.filter(p => p.category === 'home'),
  'work-business': affiliateProducts.filter(p => p.category === 'office'),
  'relationships-personal': affiliateProducts.filter(p => ['wedding', 'baby'].includes(p.category)),
  'health-safety': affiliateProducts.filter(p => p.category === 'health'),
  'food-kitchen': affiliateProducts.filter(p => p.category === 'kitchen'),
  car: affiliateProducts.filter(p => p.category === 'car'),
  electronics: affiliateProducts.filter(p => p.category === 'electronics'),
  'tech-digital': affiliateProducts.filter(p => p.category === 'electronics'),
  camping: affiliateProducts.filter(p => p.category === 'camping'),
  outdoors: affiliateProducts.filter(p => p.category === 'camping'),
  pet: affiliateProducts.filter(p => p.category === 'pet'),
  'pets-animals': affiliateProducts.filter(p => p.category === 'pet'),
  garden: affiliateProducts.filter(p => p.category === 'garden'),
  school: affiliateProducts.filter(p => p.category === 'school'),
  'school-learning': affiliateProducts.filter(p => p.category === 'school'),
  diy: affiliateProducts.filter(p => p.category === 'diy'),
  'diy-garage': affiliateProducts.filter(p => p.category === 'diy'),
  general: affiliateProducts.filter(p => ['electronics', 'camping', 'pet'].includes(p.category)),
};

// Find products matching keywords in text
export function findMatchingProducts(text: string, maxResults: number = 3): AffiliateProduct[] {
  const lowerText = text.toLowerCase();
  const scored = affiliateProducts.map(product => {
    let score = 0;
    for (const keyword of product.keywords) {
      if (lowerText.includes(keyword.toLowerCase())) {
        score += 1;
      }
    }
    // Boost score if product name matches
    if (lowerText.includes(product.name.toLowerCase())) {
      score += 2;
    }
    return { product, score };
  });
  
  return scored
    .filter(s => s.score > 0)
    .sort((a, b) => b.score - a.score)
    .slice(0, maxResults)
    .map(s => s.product);
}

// Get products for a category
export function getProductsForCategory(category: string, maxResults: number = 3): AffiliateProduct[] {
  const normalizedCategory = category.toLowerCase();
  
  // Map various category names to our product categories
  const categoryMap: Record<string, string[]> = {
    travel: ['travel'],
    home: ['home'],
    'home-life': ['home'],
    office: ['office'],
    'work-business': ['office'],
    wedding: ['wedding'],
    baby: ['baby'],
    'relationships-personal': ['wedding', 'baby'],
    health: ['health'],
    fitness: ['health'],
    'health-safety': ['health'],
    kitchen: ['kitchen'],
    'food-kitchen': ['kitchen'],
    car: ['car'],
    electronics: ['electronics'],
    tech: ['electronics'],
    'tech-digital': ['electronics'],
    camping: ['camping'],
    outdoor: ['camping'],
    outdoors: ['camping'],
    hiking: ['camping'],
    pet: ['pet'],
    pets: ['pet'],
    'pets-animals': ['pet'],
    dog: ['pet'],
    cat: ['pet'],
    garden: ['garden'],
    lawn: ['garden'],
    school: ['school'],
    'school-learning': ['school'],
    education: ['school'],
    college: ['school'],
    diy: ['diy'],
    'diy-garage': ['diy'],
    tools: ['diy'],
    general: ['electronics', 'camping', 'pet'],
  };
  
  const targetCategories = categoryMap[normalizedCategory] || ['general'];
  const products = affiliateProducts.filter(p => targetCategories.includes(p.category));
  
  // If no products found, return general products
  if (products.length === 0) {
    return affiliateProducts.slice(0, maxResults);
  }
  
  return products.slice(0, maxResults);
}

// Get random featured products
export function getFeaturedProducts(count: number = 3): AffiliateProduct[] {
  const shuffled = [...affiliateProducts].sort(() => Math.random() - 0.5);
  return shuffled.slice(0, count);
}
